import { CalendarShift } from '@core/app/types/logworkApiType'

import { DayjsType } from '@page/logwork/logwork'

/**
 * Group shifts by day
 */
export const groupShiftsByDay = (
    shifts: CalendarShift[],
    dates: { start: DayjsType; end: DayjsType }
): { [dayIndex: number]: CalendarShift[] } => {
    const shiftsByDay: { [dayIndex: number]: CalendarShift[] } = {}

    for (let i = 0; i < 7; i++) {
        const currentDate = dates.start.add(i, 'day').format('YYYY-MM-DD')
        const dayShifts = shifts.filter((shift) => shift.fromDt.split(' ')[0] === currentDate)
        if (dayShifts.length > 0) {
            shiftsByDay[i] = dayShifts
        }
    }

    return shiftsByDay
}
